import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { changeLanguage } from "../../i18n";
import { SupportedLanguage, supportedLanguages } from "../../i18n/resources";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const handleChangeLanguage = useCallback((language: SupportedLanguage) => {
    void changeLanguage(language);
  }, []);

  return (
    <div className="flex items-center gap-2 text-[12px]" aria-label={t("language.switchLabel")}>
      {supportedLanguages.map((language) => (
        <button
          key={language}
          type="button"
          onClick={() => handleChangeLanguage(language)}
          className={`min-w-[44px] rounded-[4px] border px-2 py-1 ${
            i18n.language === language ? "border-black bg-black text-white" : "border-gray-300 bg-white text-black"
          }`}
        >
          {language.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
